<template>
  <div class="card-cat col-md-4 pointer">
    <router-link :to="localizedRoute(route)">
      <div class="brd-category relative">
        <div class="card-item_mobile relative" :style="`background-image: url('${ image }')`" />
        <img
          class="card-item relative"
          :src="image"
          :alt="`card image by ${$t(category.title)}`"
          :width="parseInt(imageParams.width)"
          :height="parseInt(imageParams.height)"
          loading="eager"
          :fetchpriority="lcp ? 'high' : null"
        />
        <p class="category-name center-xs medium" >{{ $t(category.title) }} </p>
      </div>
    </router-link>
  </div>
</template>
<script>
import config from 'config';
import { mapGetters } from 'vuex';
import { s3Path } from '@vue-storefront/core/helpers';

export default {
  name: 'HomeCategoryCard',
  methods: { s3Path },
  props: {
    category: {
      type: Object,
      required: true
    },
    lcp: {
      type: Boolean,
      default: false
    },
    imageParams: {
      type: Object,
      default: () => {
        return {
          width: '276.5px',
          height: '173.19px',
          proxy: true
        }
      }
    },
    mobileFlower: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters({
      currentLocation: 'locations/getActiveLocation'
    }),
    route () {
      if (this.category.link) {
        let link = this.category.link
        if (!link.startsWith('/')) {
          link = `/${link}`
        }
        return `/${this.currentLocation.code}${link}`
      }
      return `/${this.currentLocation.code}/${this.category.code}`
    },
    image () {
      if (!this.imageParams.proxy) {
        return this.category.image
      }
      return `${config.images.baseUrl}${this.category.image}?width=${parseInt(this.imageParams.width)}&height=${parseInt(this.imageParams.height)}&image-type=image`
    }
  }
}
</script>
<style lang="scss" scoped>
  .small-title{
    @media (max-width: 990px) and (min-width: 765px){
      margin: 0;
      margin-top: 12px !important;
    }
    @media (max-width: 500px){
      margin: 0;
      margin-top: 12px !important;
    }
  }
  .card-cat {
    margin-bottom: 15px;
    flex-basis: 21%;
    max-width: 21%;

    @media (max-width: 991px) {
      flex-basis: 30%;
      max-width: 30%;
      padding: 0 5px;
    }
    @media (max-width: 768px) {
      flex-basis: 45%;
      max-width: 45%;
      padding: 0 5px;
    }

    .card-item {
      min-height: 217px;
      border-radius: 50%;
      box-shadow: 1px 2px 7px 0 rgba(0, 0, 0, 0.13);
      background-color: #ffffff;
      overflow: hidden;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      display: block;
      object-fit: cover;

      &_mobile {
        display: none;
      }

      @media (max-width: 1200px) {
        min-height: 174px;
      }
      @media (max-width: 991px) {
        min-height: 199px;
      }
      @media (max-width: 768px) {
        min-height: 234px;
      }
      @media (max-width: 768px) {
        min-height: 234px;
      }
      @media (max-width: 768px) {
        min-height: 234px;
      }
      @media (max-width: 576px) {
        display: none;

        &_mobile {
          display: block;
          min-height: auto;
          padding-bottom: 100%;
          width: 100%;
          border-radius: 50%;
          background-position: center;
          background-size: cover;
        }
      }

      img {
        display: inline-block;
        width: 100%;
        height: auto;
        position: relative;
        top: -1px;
        max-height: 173.19px;
      }

      p {
        margin-top: 5px;
        @media (min-width: 767px){
          font-size: 16px;
        }
      }
    }
  }
  .grey-card{
    img {
      filter: grayscale(100%);
      opacity: 0.5;
    }
  }
  .brd-category {
    border-radius: 50%;
    border: 1px solid #F2994A;
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;

    &:hover {
      padding: 5px;
      border-width: 2px;
    }
  }
  .category-name {
    position: absolute;
    bottom: 35%;
    left: 0;
    right: 0;
    font-size: 14px;
    background: #fff;
    width: 85%;
    margin: 0 auto;
    border-radius: 15px;
    padding: 3px;
    @media (max-width: 500px) {
      font-size: 12px;
      margin: 0 auto;
    }
  }
</style>
